<button type="button"
  class="user-chip"
  [matMenuTriggerFor]="menu"
  [attr.aria-label]="'term.user-menu' | translate">
  <cmn-auth-user-name [showName]="showName"></cmn-auth-user-name>
  <mat-icon class="user-chip__arrow">expand_more</mat-icon>
</button>
